<template>
	<div>
		<v-data-table
			v-if="(roleName === 'SYSTEM_ADMIN' || roleName === 'SYSTEM_USER') && hospitals"
			class="medical-staff-data-table"
			fixed-header
			dense
			:headers="headers"
			:no-data-text="$t('no-data-available')"
			:loading-text="$t('loading')"
			:loading="loading"
			:items="filteredOrganizations"
			item-key="medicalInstitutionName"
			:height="pageHeight(174)"
			ref="table"
			:items-per-page="-1"
			single-expand
			:footer-props="getDataTableFooterProps('officesTable')">
			<template #item="{ item, index, expand, isExpanded }">
				<tr :class="[getRowsForDataTable(index), { 'expanded-row': isExpanded }]" @click="expand(!isExpanded)">
					<td class="table-border-bottom text-left d-flex align-center">
						<v-btn small icon>
							<v-icon small color="primary">
								{{ isExpanded ? 'mdi-arrow-down-drop-circle' : 'mdi-arrow-right-drop-circle' }}
							</v-icon>
						</v-btn>
						<span class="font-weight-bold ml-1 mr-1">{{ item.medicalInstitutionName }}</span>
						<v-chip pill x-small color="primary" class="ml-auto text--black custom-chip-size" label>
							{{ item.offices.length }} {{ item.offices.length > 1 ? $t('locations') : $t('location') }}
						</v-chip>
					</td>
				</tr>
			</template>
			<template #expanded-item="{ item }">
				<tr style="cursor: default; background-color: #fff !important">
					<td class="pa-3">
						<v-data-table
							:items="item.offices"
							:headers="insideHeaders"
							dense
							:items-per-page="-1"
							hide-default-footer
							class="data-table-outline"
							:height="pageHeight(95)"
							fixed-header>
							<template #item="{ item, index }">
								<tr :class="getRowsForDataTable(index)">
									<td class="text-left font-weight-medium">
										{{ item.hospitalName }}
									</td>
									<td class="text-right">
										<v-menu left bottom class="py-0" offset-y transition="slide-x-transition">
											<template #activator="{ on, attrs }">
												<v-btn icon color="main_black" v-bind="attrs" v-on="on">
													<v-icon>mdi-dots-horizontal</v-icon>
												</v-btn>
											</template>
											<v-list class="px-0" dense>
												<v-list-item class="py-0 my-0" link dense @click="selectedHospitalRow(item)">
													<v-list-item-icon class="mx-1">
														<v-icon class="icon-img mdi-18px" color="black">mdi-eye</v-icon>
													</v-list-item-icon>
													<v-list-item-content class="font-bold font-size14">{{ $t('view') }}</v-list-item-content>
												</v-list-item>
												<v-divider />
												<v-list-item class="py-0 my-0" link dense @click="generateCSV(item)">
													<v-list-item-icon class="mx-1">
														<v-icon class="icon-img mdi-18px" color="main_black">mdi-file-excel</v-icon>
													</v-list-item-icon>
													<v-list-item-content class="font-weight-bold font-size14">CSV</v-list-item-content>
												</v-list-item>
											</v-list>
										</v-menu>
									</td>
								</tr>
							</template>
						</v-data-table>
					</td>
				</tr>
			</template>
		</v-data-table>
		<v-data-table
			v-if="
				(roleName === 'ORGANIZATION_ADMIN' ||
					roleName === 'HOSPITAL_ADMIN' ||
					roleName === 'DOCTOR' ||
					roleName === 'NURSE') &&
				filteredHospitals
			"
			class="medical-staff-data-table"
			fixed-header
			dense
			:headers="headers"
			:headers-length="headers.length"
			:no-data-text="$t('no-data-available')"
			:loading-text="$t('loading')"
			:loading="loading"
			:search="appBarSearch"
			:items="hospitalsWithAdmins"
			item-key="id"
			sort-by="id"
			@click:row="selectedHospitalRow"
			:height="pageHeight(174)"
			single-expand
			:expanded.sync="expanded"
			:footer-props="getDataTableFooterProps('officesTable')"
			:items-per-page="-1">
			<template #item="{ item, index }">
				<tr :class="getRowsForDataTable(index)" @click="selectedHospitalRow(item)">
					<td class="table-font-size">
						<span>{{ item.hospitalName }}</span>
					</td>
					<td class="table-font-size">
						<v-chip class="mx-1" v-for="(admin, index) in item.admins" :key="index" label pill x-small color="primary">
							{{ admin }}
						</v-chip>
					</td>
					<td class="text-right">
						<v-menu left bottom offset-y class="py-0" transition="slide-x-transition">
							<template #activator="{ on, attrs }">
								<v-btn icon color="black" v-bind="attrs" v-on="on">
									<v-icon class="mdi mdi-18px mdi-dots-horizontal"></v-icon>
								</v-btn>
							</template>
							<v-list>
								<v-list-item link dense @click="selectedHospitalRow(item)">
									<v-list-item-icon class="mr-1">
										<v-icon class="icon-img mdi-18px" color="black">mdi-eye</v-icon>
									</v-list-item-icon>
									<v-list-item-content class="font-bold font-size14">{{ $t('view') }}</v-list-item-content>
								</v-list-item>
								<v-divider />
								<v-list-item class="py-0 my-0" link dense @click="generateCSV(item)">
									<v-list-item-icon class="mr-1">
										<v-icon class="icon-img mdi-18px" color="main_black">mdi-file-document</v-icon>
									</v-list-item-icon>
									<v-list-item-content class="font-bold font-size14">CSV</v-list-item-content>
								</v-list-item>
							</v-list>
						</v-menu>
					</td>
				</tr>
			</template>
			<template #[`group.header`]="{ group, headers, items }">
				<td class="text-left" :colspan="headers.length">
					<span>{{ group }}</span>
					<v-chip class="mb-1 white--text" pill x-small color="primary">
						{{ items.length }}
					</v-chip>
				</td>
			</template>
		</v-data-table>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { showSuccessAlert, getDataTableFooterProps, getRowsForDataTable, toggleHeaders } from '@/utils/utilities';

export default {
	data: () => ({
		loading: false,
		headerClass: 'color-header',
		expanded: [],
		ecpLocationMapping: [],
	}),
	computed: {
		...mapState({
			hospitals: (state) => state.hospitals.hospitals,
			filteredHospitals: (state) => state.hospitals.filteredHospitals,
			hospitalAdminUsers: (state) => state.users.hospitalAdmins,
			allVerifiers: (state) => state.verifiers.allverifires,
			generatedCsvFile: (state) => state.billings.generatedCsvFile,
			selectedHospital: (state) => state.hospitals.selectedHospital,
		}),
		...mapGetters({
			pageHeight: 'pageHeight',
			roleName: 'authentication/getRole',
			appBarSearch: 'filterbar/getSearch',
			appBarMedicalInstitution: 'filterbar/getMedicalInstitution',
		}),
		hospitalsWithAdmins () {
			return this.hospitals.map((hospital) => {
				return {
					...hospital,
					admins: this.getHospitalAdmins(hospital),
				};
			});
		},
		headers () {
			if (this.roleName === 'SYSTEM_ADMIN' || this.roleName === 'SYSTEM_USER') {
				return [
					{
						text: this.$t('name'),
						value: 'hospitalName',
					},
				];
			} else {
				return [
					{
						text: this.$t('location-name'),
						value: 'hospitalName',
					},
					{
						text: this.$t('admins'),
						value: 'admin',
						align: 'start',
					},
					{
						text: '',
						value: 'actions',
						sortable: false,
					},
				];
			}
		},
		insideHeaders () {
			return [
				{ text: this.$t('location-name'), value: 'hospitalName' },
				{ text: '', value: 'actions' },
			];
		},
		filteredHospitals () {
			let calculateFilteredHospitals = this.hospitals;
			if (this.appBarMedicalInstitution !== 0 && this.appBarMedicalInstitution !== null) {
				// filter by medicalInstitutionId
				calculateFilteredHospitals = calculateFilteredHospitals.filter(
					(h) => h.medicalInstitutionId === this.appBarMedicalInstitution,
				);
			}
			return calculateFilteredHospitals;
		},
		filteredOrganizations () {
			if (!this.appBarSearch) {
				return this.groupedOrganizations;
			}
			const searchTerm = this.appBarSearch.toLowerCase();
			return this.groupedOrganizations.reduce((result, group) => {
				if (group.medicalInstitutionName.toLowerCase().includes(searchTerm)) {
					result.push(group);
					return result;
				}
				const matchingLocations = group.offices.filter((location) => {
					return location.hospitalName.toLowerCase().includes(searchTerm);
				});
				if (matchingLocations.length > 0) {
					result.push({
						...group,
						offices: matchingLocations,
					});
				}
				return result;
			}, []);
		},
		groupedOrganizations () {
			let calculateFilteredHospitals = this.hospitals;
			if (this.appBarMedicalInstitution !== 0 && this.appBarMedicalInstitution !== null) {
				calculateFilteredHospitals = calculateFilteredHospitals.filter(
					(h) => h.medicalInstitutionData.id === this.appBarMedicalInstitution,
				);
			}
			return calculateFilteredHospitals.reduce((groups, item) => {
				let group = groups.find((g) => g.medicalInstitutionName === item.medicalInstitutionData.institutionName);
				if (!group) {
					group = { medicalInstitutionName: item.medicalInstitutionData.institutionName, offices: [] };
					groups.push(group);
				}
				group.offices.push(item);
				return groups;
			}, []);
		},
	},
	async mounted () {
		await this.getAllVerifiers();
		await this.getHospitals();
		if (this.roleName !== 'SYSTEM_ADMIN' && this.roleName !== 'SYSTEM_USER') {
			await this.getHospitalAdminUsers();
		}
	},
	methods: {
		toggleHeaders,
		getRowsForDataTable,
		getDataTableFooterProps,
		getHospitalAdmins (item) {
			if (this.hospitalAdminUsers == null) {
				return [];
			}
			const admins = [];
			this.hospitalAdminUsers.forEach((hospitalData) => {
				if (hospitalData.hospitalAssignedData.id === item.id) {
					admins.push(`${hospitalData.firstName} ${hospitalData.lastName}`);
				}
			});
			return admins;
		},

		async getHospitalAdminUsers () {
			await this.$store.dispatch('users/getHospitalAdmins').then(() => {
				this.loading = false;
			});
		},
		async getAllVerifiers () {
			if (this.allVerifiers == null) {
				await this.$store.dispatch('verifiers/getAllVerifiers').then(() => {});
			}
		},
		async getHospitals () {
			this.loading = true;
			await this.$store.dispatch('hospitals/getHospitals').then(() => {
				this.loading = false;
			});
			this.toggleHeaders();
		},
		async editHospital (item) {
			await this.$store.commit('hospitals/SELECTED_HOSPITAL', item);
			this.$store.commit('SET_EDIT_DETAILS_DRAWER', true);
		},
		selectedHospitalRow (item) {
			this.editHospital(item);
			this.getEcpMappingLocation();
		},
		async generateCSV (item) {
			const currentDate = new Date();
			const currentYear = currentDate.getFullYear();
			const currentMonth = currentDate.getMonth() + 1;
			const hospitalId = item.id;
			const data = { hospitalId: hospitalId, month: currentMonth, year: currentYear };
			await this.$store.dispatch('billings/generateCsvHospitalPatientsForMonth', data).then((res) => {
				showSuccessAlert(this.$t('success-operation'));
				const url = window.URL.createObjectURL(new Blob([this.generatedCsvFile.data]));
				const link = document.createElement('a');
				link.href = url;
				// link.setAttribute('download', 'location-billings-csv.csv');
				link.setAttribute('download', 'location-billings-csv.zip'); // Updated to reflect zipped file
				document.body.appendChild(link);
				link.click();
			});
		},
		getEcpMappingLocation () {
			if (this.roleName === 'SYSTEM_ADMIN' || this.roleName === 'SYSTEM_USER') {
				this.$store.dispatch('hospitals/getEcpMappingLocation', this.selectedHospital.id).then((res) => {
					this.ecpLocationMapping = null;
					if (res.data) {
						this.ecpLocationMapping = res.data;
						this.ecpLocationMapping.userCreationIsAutomaticValue = this.ecpLocationMapping.userCreationIsAutomatic
							? 1
							: 0;
						this.ecpLocationMapping.residentCreationIsAutomaticValue = this.ecpLocationMapping
							.residentCreationIsAutomatic
							? 1
							: 0;
						this.ecpLocationMapping.finalizeMeasurementAutomaticallyValue = this.ecpLocationMapping
							.finalizeMeasurementAutomatically
							? 1
							: 0;
					}
				});
			}
		},
	},
};
</script>
